module.exports = "https://cdn-shared.mathletics.com/mathsaz/100/assets/images/f55b5c8edc53380058f6177f77e2f8e3.svg";